import $ from 'jquery';

$( document ).on( 'click', '.woocommerce-loop-product__links__link-quickview', function ( e ) {
	e.preventDefault();

	const productId = $( this ).data( 'product-id' );
	const productUrl = $( this ).data( 'product-url' );

	if ( productId === undefined || productUrl === undefined ) {
		return;
	}

	const $quickviewContent = $( '.product-quickview__content' );
	const $quickviewUrl = $( '.product-quickview__link' );

	if ( !$quickviewContent.length || !$quickviewUrl.length ) {
		return;
	}

	$quickviewContent.html( $( 'li.product.post-' + productId ).html() );
	$quickviewUrl.attr( 'href', productUrl );

	new Foundation.Equalizer( $quickviewContent );

	const modal = new Foundation.Reveal( $( '#anssems-product-quickview' ) );

	modal.open();

	return false;
} );